module.exports = __webpack_public_path__ + "static/media/hello_teacher.b9f735f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/hello_teacher.png
// module id = 508
// module chunks = 0